module.exports = __webpack_public_path__ + "img/handbook-explosion_cn.e80607e.jpg";